import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { roomRateAvailabilityQueryKeys } from './roomRateAvailabilityQueryKeys';

export function useGetRoomRateBlackoutDates(
  propertyId: string | undefined,
  roomTypeId: string | undefined,
  roomRateId: string | undefined,
) {
  return useQuery<Array<App.BlackoutDate>>({
    queryKey: roomRateAvailabilityQueryKeys.blackout(propertyId ?? '', roomTypeId ?? '', roomRateId ?? ''),
    queryFn: async () =>
      (await ReservationService.getBlackoutDates(propertyId, roomTypeId, roomRateId)).result?.dates ?? [],
    enabled: !!propertyId && !!roomTypeId && !!roomRateId,
  });
}
